<template>
  <thead>
    <tr>
      <th
        v-if="isSelectable"
        style="width: 35px; margin: 0;"
      >
        <div class="head-content">
          <div
            class="checkbox checkbox-custom checkbox-primary"
            @click.stop="onToggleSelection"
          >
            <input
              type="checkbox"
              :checked="isCurrentViewSelected"
            />
            <label />
          </div>
        </div>
      </th>

      <th
        v-for="header in headers"
        :key="header.field"
        :style="`width: ${header.width ? header.width : 'auto'}`"
      >
        <div
          class="head-content"
          @click.stop="onSort(header.field, header.sort)"
        >
        <!-- TODO: keep in observation -->
          <span v-html="header.title" class="text-center" style="display: block;width: 100%;"></span>

          <div
            class="sorting-columns"
            v-if="isSortEnabled && header.sort !== false"
          >
            <i
              class="fa fa-caret-up"
              :class="{
                active: sortKey == header.field && sortDirection == 'asc',
                hidden: sortKey == header.field && sortDirection == 'desc',
              }"
            />
            <i
              class="fa fa-caret-down"
              :class="{
                active: sortKey == header.field && sortDirection == 'desc',
                hidden: sortKey == header.field && sortDirection == 'asc',
              }"
            />
          </div>
        </div>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "wt-header",
  props: {
    storeName: {
      type: String,
    },
    headers: {
      type: Array,
    },
    isSortEnabled: {
      type: Boolean,
      default: true,
    },
    isSelectable: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
    },
  },
  methods: {
    onSort(sortKey, canBeSort) {
      if (!this.isSortEnabled || canBeSort === false) return;

      this.dispatch("applySort", sortKey);
      this.$emit("onSort");
    },
    onToggleSelection() {
      this.dispatch("selectAllRows", this.data);
    },
    dispatch(action, payload) {
      this.$store.dispatch(`${this.storeName}/table/${action}`, payload);
    },
  },
  computed: {
    state() {
      return this.$propertyByString(this.$store.state, this.storeName).table;
    },
    sortKey() {
      return this.state.sortParams.key;
    },
    sortDirection() {
      return this.state.sortParams.direction;
    },
    selectedRows() {
      return this.state.selection;
    },
    isCurrentViewSelected() {
      const selectedRows = this.selectedRows.map((item) =>
        JSON.stringify(item)
      );
      const selection = this.data.filter((item) =>
        selectedRows.includes(JSON.stringify(item))
      );

      return selection.length == this.data.length && this.data.length > 0;
    },
  },
};
</script>
